module.exports = __webpack_public_path__ + "static/media/01-meeting-smile.78126454.jpg";